__turbopack_context__.v({
  "backButton": "feedback-module__tqcdmG__backButton",
  "button": "feedback-module__tqcdmG__button",
  "charCount": "feedback-module__tqcdmG__charCount",
  "container": "feedback-module__tqcdmG__container",
  "error": "feedback-module__tqcdmG__error",
  "feedbackBox": "feedback-module__tqcdmG__feedbackBox",
  "footer": "feedback-module__tqcdmG__footer",
  "form": "feedback-module__tqcdmG__form",
  "header": "feedback-module__tqcdmG__header",
  "input": "feedback-module__tqcdmG__input",
  "inputGroup": "feedback-module__tqcdmG__inputGroup",
  "logo": "feedback-module__tqcdmG__logo",
  "optional": "feedback-module__tqcdmG__optional",
  "redirectText": "feedback-module__tqcdmG__redirectText",
  "required": "feedback-module__tqcdmG__required",
  "subtitle": "feedback-module__tqcdmG__subtitle",
  "successBox": "feedback-module__tqcdmG__successBox",
  "successIcon": "feedback-module__tqcdmG__successIcon",
  "textarea": "feedback-module__tqcdmG__textarea",
  "title": "feedback-module__tqcdmG__title",
});
